// Hero-band heights, shared in one place so the persistent video backdrop
// (sized per route in PersistentHeroBackdrop) stays exactly in sync with the
// transparent hero sections that overlay it (home + PageHero). If these drift,
// the video band misaligns against the title block / bleeds over page content.
//
// Wired in three spots that must agree:
//   - App.tsx route `handle.heroHeight`  → sizes the persistent backdrop layer
//   - routes/home.tsx hero section        → the 90vh band on the landing page
//   - components/layout/PageHero.tsx      → the compact 38vh band elsewhere
export const HOME_HERO_HEIGHT = "min(90vh, 820px)";
export const PAGE_HERO_HEIGHT = "min(38vh, 320px)";
